import React from "react";

export type EmailUnsubscribeLayoutProps = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  actions?: React.ReactNode;
};

export const EmailUnsubscribeLayout: React.FC<EmailUnsubscribeLayoutProps> = ({
  title,
  subtitle,
  actions,
}) => (
  <div className="flex min-h-svh bg-primary md:items-center md:justify-center">
    <div className="flex w-full flex-col gap-8 p-8 md:max-w-112 md:rounded-2xl md:border md:border-secondary">
      <div className="flex flex-1 flex-col justify-center gap-3">
        <h1 className="text-display-sm font-semibold text-pretty text-primary">
          {title}
        </h1>
        <p className="text-md text-pretty text-tertiary">{subtitle}</p>
      </div>
      {actions && <div className="flex flex-col gap-2">{actions}</div>}
    </div>
  </div>
);
